import { createSlice } from "@reduxjs/toolkit";
import { fetchKycVerifications } from "./KycStatusList.thunk";

const baseState = {
  verificationsList: [],
  statusFilter: "all",
  page: 1,
  pageSize: 10,
  totalPages: 0,
  totalRecords: 0,
  status: "idle",
  error: null,
  latestRequestId: null,
};

const initialState = {
  ...baseState,
};

export const kycStatusListSlice = createSlice({
  name: "kycStatusList",
  initialState,
  reducers: {
    setStatusFilter: (state, action) => {
      state.statusFilter = action.payload;
      state.page = 1;
    },
    ResetKycStatusListStore: () => ({ ...baseState }),
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchKycVerifications.pending, (state, action) => {
        state.status = "loading";
        state.error = null;
        state.latestRequestId = action.meta.requestId;
      })
      .addCase(fetchKycVerifications.fulfilled, (state, action) => {
        if (action.meta.requestId !== state.latestRequestId) {
          return;
        }

        const {
          verificationsList,
          page,
          page_size,
          total_pages,
          total_records,
        } = action.payload;

        state.status = "succeeded";
        state.verificationsList = verificationsList;
        state.page = page;
        state.pageSize = page_size;
        state.totalPages = total_pages;
        state.totalRecords = total_records;
        state.error = null;
      })
      .addCase(fetchKycVerifications.rejected, (state, action) => {
        if (action.meta.requestId !== state.latestRequestId) {
          return;
        }

        state.status = "failed";
        state.verificationsList = [];
        state.page = 1;
        state.totalPages = 0;
        state.totalRecords = 0;
        state.error =
          action?.payload?.message || "Error fetching KYC verifications";
      });
  },
});

export const { setStatusFilter, ResetKycStatusListStore } =
  kycStatusListSlice.actions;

export default kycStatusListSlice.reducer;
